import React from 'react';
import { StyleSheet, View, ScrollView, Appearance, Platform } from 'react-native';
import { router, useLocalSearchParams } from 'expo-router';
import { Button, Text, TextInput } from 'react-native-paper';
import axios from 'axios';
import { MotiView } from 'moti';
import { Skeleton } from 'moti/skeleton';
import { useForm, Controller } from "react-hook-form"
import Select from '../../../components/Select/Select';
import { MainContext } from '../../../contexts/MainContext';
import Spacer from '../../../components/Spacer/Spacer';
import Checkbox from '../../../components/CheckBox/CheckBox';
import TwinNumberTextInput from '../../../components/TwinNumberTextInput/TwinNumberTextInput';
import HaveForm from '../../../assets/haveForm.png';

export default function Page() {
  const myContext = React.useContext(MainContext);
  const { id } = useLocalSearchParams();
  const colorScheme = Appearance.getColorScheme();
  const siteAddsTypes = myContext.addsTypes ? myContext.addsTypes : {transactions:[]};
  const [pageLoading, setPageLoading] = React.useState(true);
  const [addAdsFormActive, setAddAdsFormActive] = React.useState(false);
  const [step, setStep] = React.useState(1);    
  const [crm, setCrm] = React.useState([]);                                                  
  const [countries, setCountries] = React.useState([]);
  const [ostan, setOstan] = React.useState([]);
  const [shahrestan, setShahrestan] = React.useState([]);
  const [mantaghe, setMantaghe] = React.useState([]);
  const [transactions, setTransactions] = React.useState([]);
  const [sellStatus, setSellStatus] = React.useState([]);
  const [landTypes, setLandTypes] = React.useState([]);
  const [transactionsMeta, setTransactionsMeta] = React.useState([]);
  const [landTypesMeta, setLandTypesMeta] = React.useState([]);
  const [landTypesWelfareAmenities, setLandTypesWelfareAmenities] = React.useState([]);
  const [landTypesBranches, setLandTypesBranches] = React.useState([]);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  React.useEffect(() => {
    getFristData();
  }, [])

  const getFristData = () => {
    setPageLoading(true);
    axios.all([
      axios.get(`/panel/customer/edit/${id}`),
    ])
      .then(axios.spread((crmData) => {
        if(crmData.data.status === true) {
            setCrm(crmData.data.crm);

            console.log(crmData.data.crm);
            
            let countryData = [];
            Object.values(crmData.data.countries).map((item) => {
              countryData.push({key: item._id, value: item.title});
            })
            setCountries(countryData);
  
            let ostanData = [];
            Object.values(crmData.data.ostans).map((item) => {
              ostanData.push({key: item._id, value: item.title});
            })
            setOstan(ostanData);
  
            let shahrestanData = [];
            Object.values(crmData.data.shahrestan).map((item) => {
              shahrestanData.push({key: item._id, value: item.title});
            })
            setShahrestan(shahrestanData);
  
            let mantagheData = [];
            Object.values(crmData.data.mantaghe).map((item) => {
              mantagheData.push({key: item._id, value: item.title});
            })
            setMantaghe(mantagheData);
  
            if(Object.keys(siteAddsTypes).length > 2) {
              let transactions = [];
              Object.values(siteAddsTypes.transactions).map((item) => {
                transactions.push({key: item._id, value: item.term_name, sell_status: item.sell_status, add_meta_list: item.add_meta_list});
              });
              setTransactions(transactions);
        
              if(crmData.data.crm.categoryInformation.transaction) {
                let targetTransaction = Object.values(transactions).filter((item) => item.key === crmData.data.crm.categoryInformation.transaction);
                
                let selStatusData = [];
                Object.values(targetTransaction[0].sell_status).map((item, i) => {
                  selStatusData.push({key: item._id, value: item.term_name, land_types: item.land_types});
                })
                setSellStatus(selStatusData);
  
                if(crmData.data.crm.categoryInformation.sell_status) {
                  if(targetTransaction[0]?.sell_status) {
                    let targetSellStatus = Object.values(targetTransaction[0].sell_status).filter((item) => item._id === crmData.data.crm.categoryInformation.sell_status);
                    
                    let landtypeData = [];
                    Object.values(targetSellStatus[0].land_types).map((item, i) => {
                      landtypeData.push({key: item._id, value: item.term_name, add_meta_list: item.add_meta_list, welfare_amenities: item.welfare_amenities, branches: item.branches});
                    })
                    setLandTypes(landtypeData);
                  }
                }
              }
            }
  
            setTransactionsMeta(crmData.data.crm.metaList);
            setLandTypesWelfareAmenities(crmData.data.crm.welfareAmenities);
            setLandTypesBranches(crmData.data.crm.branches);
          }
      }))
      .catch(myContext.handleAxiosError)
      .finally(() => setPageLoading(false));
  }

  const getState = (id) => {
    axios.all([
      axios.get(`/get_ostan/${id}`),
    ])
      .then(axios.spread((ostan) => {
        let data = [];
        Object.values(ostan.data).map((item) => {
          data.push({key: item._id, value: item.title});
        })
        setOstan(data);
      }))
      .catch(myContext.handleAxiosError);
  }

  const getShahrestans = (id) => {
    axios.all([
      axios.get(`/get_shahrestans?ostan=${id}`),
    ])
      .then(axios.spread((shahresten) => {
        let data = [];
        Object.values(shahresten.data).map((item) => {
          data.push({key: item._id, value: item.title});
        })
        setShahrestan(data);
      }))
      .catch(myContext.handleAxiosError);
  }

  const getMantaghe = (id) => {
    axios.all([
      axios.get(`/get_manategh/${id}`),
    ])
      .then(axios.spread((mantaghe) => {
        let data = [];
        Object.values(mantaghe.data).map((item) => {
          data.push({key: item._id, value: item.title});
        })
        setMantaghe(data);
      }))
      .catch(myContext.handleAxiosError);
  }

  const getSellStatus = (data) => {
    let sellStatusData = [];
    if(data.sell_status) {
      Object.values(data.sell_status).map((item) => {
        sellStatusData.push({key: item._id, value: item.term_name, land_types: item.land_types});
      })
      setSellStatus(sellStatusData);
    }
    if(data.add_meta_list) {
      setTransactionsMeta(data.add_meta_list);
    }
  }

  const getLandType = (data) => {
    let landtypesData = [];
    if(data.land_types) {
      Object.values(data.land_types).map((item) => {
        landtypesData.push({key: item._id, value: item.term_name, add_meta_list: item.add_meta_list, welfare_amenities: item.welfare_amenities, branches: item.branches});
      })
    }
    setLandTypes(landtypesData);
  }

  const getExtraMeta = (data) => {
    if(data.add_meta_list) {
      setLandTypesMeta(data.add_meta_list);
    } 
    if(data.welfare_amenities) {
      setLandTypesWelfareAmenities(data.welfare_amenities);
    }
    if(data.branches) {
      setLandTypesBranches(data.branches);
    }
  }

  const stepRender = (step) => {
    switch (step) {
      case 1:
        return (
          <View key={1}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>اطلاعات منطقه</Text>
            {/* <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="کشور"
                  placeholder="جستجو کشور مورد نظر"
                  options={countries}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.country}
                  onValueChange={onChange}
                  onSelect={(data) => getState(data.key)}
                />
              )}
              name="region[country]"
              defaultValue={crm.regionIds?.country}
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="استان"
                  placeholder="جستجو استان مورد نظر"
                  options={ostan}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.ostan}
                  onValueChange={onChange}
                  onSelect={(data) => getShahrestans(data.key)}
                />
              )}
              name="region[ostan]"
              defaultValue={crm.regionIds?.ostan}
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="شهرستان"
                  placeholder="جستجو شهرستان مورد نظر"
                  options={shahrestan}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.shahrestan}
                  onValueChange={onChange}
                  onSelect={(data) => getMantaghe(data.key)}
                />
              )}
              name="region[shahrestan]"
              defaultValue={crm.regionIds?.shahrestan}
            /> */}
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="منطقه"
                  placeholder="جستجو منطقه مورد نظر"
                  options={mantaghe}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.mantaghe}
                  onValueChange={onChange}
                  onSelect={(data) => {}}
                  multiple
                />
              )}
              name="region[mantaghe]"
              defaultValue={crm.regionIds?.mantaghe}
            />
          </View>
        );
      break;
      case 2:
        return (
          <View key={2}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>اطلاعات مشتری</Text>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="نام مشتری"
                  placeholder="نام مشتری را بدون نوشتن آقا/خانم وارد کنید"
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  disabled
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors.user?.name}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  value={value}
                />
              )}
              name="user[name]"
              defaultValue={crm.user.name}
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="شماره مشتری"
                  placeholder="شماره مشتری را بصورت دقیق وارد کنید"
                  mode="outlined"
                  disabled
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors.user?.mobile}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  defaultValue={value}
                  keyboardType='number-pad'
                />
              )}
              name="user[mobile]"
              defaultValue={crm.user.mobile}
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="جنسیت"
                  placeholder="جستجو جنسیت مورد نظر"
                  options={[{key: 'male', value: 'مرد'}, {key: 'female', value: 'زن'}]}
                  disabled
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.user?.sex}
                  onValueChange={onChange}
                  onSelect={(data) => {}}
                />
              )}
              name="user[sex]"
              defaultValue={crm.user.sex}
            />
          </View>
        );
      break;
      case 3:
        return (
          <View key={3}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>دسته بندی‌ها</Text>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="نوع معامله"
                  placeholder="جستجو نوع معامله مورد نظر"
                  options={transactions}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.transaction}
                  onValueChange={onChange}
                  onSelect={(data) => getSellStatus(data)}
                />
              )}
              name="transaction"
              defaultValue={crm.categoryInformation?.transaction}
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="کاربری ملک"
                  placeholder="جستجو کاربری ملک مورد نظر"
                  options={sellStatus}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.sell_status}
                  onValueChange={onChange}
                  onSelect={(data) => getLandType(data)}
                />
              )}
              name="sell_status"
              defaultValue={crm.categoryInformation?.sell_status}
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="نوع ملک"
                  placeholder="جستجو نوع ملک مورد نظر"
                  options={landTypes}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.land_type}
                  onValueChange={onChange}
                  onSelect={(data) => getExtraMeta(data)}
                />
              )}
              name="land_type"
              defaultValue={crm.categoryInformation?.land_type}
            />
          </View>
        );
      break;
      case 4:
        return (
          <View key={4}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>اطلاعات ملک</Text>
            {Object.keys(transactionsMeta).length > 0 && Object.values(transactionsMeta).map(item => renderFormItems(item))}
            {Object.keys(landTypesMeta).length > 0 && Object.values(landTypesMeta).map(item => renderFormItems(item))}
          </View>
        );
      break;
      case 5:
        return (
          <View key={5}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>امکانات رفاهی</Text>
            {Object.keys(landTypesWelfareAmenities).length > 0 && Object.values(landTypesWelfareAmenities).map(item => renderFormItems(item))}
          </View>
        );
      break;
      case 6:
        return (
          <View key={6}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>انشعابات</Text>
            {Object.keys(landTypesBranches).length > 0 && Object.values(landTypesBranches).map(item => renderFormItems(item))}
          </View>
        );
      break;
    }
  }

  const renderFormItems = (data) => {
    switch (data.type) {
      case 'number':
        return (
          <Controller
            control={control}
            rules={{
              // required: data.required === 'on' ? true : false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <TwinNumberTextInput
                label={data.label}
                placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                mode="outlined"
                activeOutlineColor="#c6c5c4"
                style={{ marginBottom: 24, fontSize: 14 }}
                error={errors[data.id]}
                onBlur={onBlur}
                myOnChangeText={onChange}
                value={value}
                keyboardType='number-pad'
              />
            )}
            name={data.id}
            defaultValue={data.value}
          />
        );
      break;
      case 'text':
          return (
            <Controller
              control={control}
              rules={{
                // required: data.required === 'on' ? true : false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label={data.label}
                  placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors[data.id]}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  defaultValue={value}
                />
              )}
              name={data.id}
              defaultValue={data.value}
            />
          );
      break;
      case 'select':
        let options = [];
        if(data.choices && Object.keys(data.choices).length > 0) {
          Object.values(data.choices).map((item, i) => {
            options.push({key: item.id, value: item.label});
          })
        }
        return (
          <Controller
            control={control}
            rules={{
              // required: data.required === 'on' ? true : false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Select
                label={data.label}
                placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                options={options}
                selectedValue={value}
                onBlur={onBlur}
                error={errors[data.id]}
                onValueChange={onChange}
                onSelect={(data) => {}}
                multiple
              />
            )}
            name={data.id}
            defaultValue={data.value}
          />
        );
      break;
      case 'on-off':
        return (
          <Controller
            control={control}
            rules={{
              // required: data.required === 'on' ? true : false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Checkbox onChange={onChange} onBlur={onBlur} value={value} label={data.label} />
            )}
            name={data.id}
            defaultValue={data.value}
          />
        );
      break;
    }
  }

  const validateNextStep = (data) => {
    if(step === 6) {
      formSubmit(data);
    } else {
      setStep(step + 1);
    }
  }

  const formSubmit = (values) => {
    setSubmitLoading(true);
    Object.keys(values).forEach(key => values[key] === undefined ? delete values[key] : {});
    axios.all([
      axios.put(`/panel/customer/edit/${id}`, values),
    ])
      .then(axios.spread((response) => {
        if(response.data.success === true) {
          myContext.activateSnackbar(true, 'مشتری مورد نظر با موفقیت ویرایش شد'); 
          router.push('/myCustomer');
        }
        if(response.data.success === false) {
          myContext.activateSnackbar(true, response.data.message);
        }
        if(response.data.error) {
          
        }
      }))
      .catch(myContext.handleAxiosError)
      .finally(() => setSubmitLoading(false));
  }

  if(pageLoading) {
    return (
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={{ flex: 1, justifyContent: 'space-between', paddingVertical: 16, paddingHorizontal: 18 }}
        animate={{ backgroundColor: colorScheme === 'dark' ? '#000000' : '#ffffff' }}
      >
        <View>
          <Skeleton colorMode={colorScheme} width={250} />
          <Spacer height={24} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
          <Spacer height={24} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
          <Spacer height={24} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
          <Spacer height={24} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
        </View>
        <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
      </MotiView>
    );
  } else {
    return (
      <View style={{ flex: 1, justifyContent: 'space-between', backgroundColor: '#fcfcfd', paddingTop: 16 }}>
        <View style={styles.stepContiner}>
          <View style={styles.stepLine} />
          <View style={step === 1 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 1 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
          <View style={step === 2 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 2 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
          <View style={step === 3 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 3 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
          <View style={step === 4 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 4 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
          <View style={step === 5 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 5 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
          <View style={step === 6 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 6 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
        </View>
        <ScrollView style={styles.stepContentContiner} contentContainerStyle={{ paddingHorizontal: 18, paddingTop: 8 }}>
          {stepRender(step)}
        </ScrollView>
        <View style={styles.stepButtons}>
          {step > 1 && <Button labelStyle={{ fontSize: 16, color: '#3F3E3D' }} style={{ width: '48%', marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="outlined" onPress={() => setStep(step - 1)}>قبلی</Button>}
          {
            step === 6 ?
              <Button loading={submitLoading} disabled={submitLoading} labelStyle={{ fontSize: 16 }} style={{ width: step > 1 ? '48%' : '100%', marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={handleSubmit(validateNextStep)}>ویرایش مشتری</Button>
            :
              <Button labelStyle={{ fontSize: 16 }} style={{ width: step > 1 ? '48%' : '100%', marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={handleSubmit(validateNextStep)}>بعدی</Button>
          }
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  shape: {
    justifyContent: 'center',
    height: 250,
    width: 250,
    borderRadius: 25,
    marginRight: 10,
    backgroundColor: 'white',
  },
  stepContiner: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 18
  },
  stepLine: {
    width: '100%',
    height: 2,
    backgroundColor: '#D1D5DB',
    position: 'absolute',
    top: '50%',
    marginHorizontal: 18
  },
  stepItem: {
    width: 24,
    height: 24,
    backgroundColor: '#fcfcfd',
    borderWidth: 2,
    borderColor: '#FF0000',
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center'
  },
  stepItemDeActive: {
    width: 24,
    height: 24,
    backgroundColor: '#fcfcfd',
    borderWidth: 2,
    borderColor: '#D1D5DB',
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center'
  },
  stepItemDot: {
    width: 8,
    height: 8,
    backgroundColor: '#FF0000',
    borderRadius: 8
  },
  stepItemDotDeActive: {
    width: 8,
    height: 8,
    backgroundColor: '#fcfcfd',
    borderRadius: 8
  },
  stepContentContiner: {
    flex: 1,
    width: '100%',
    marginTop: 24,
  },
  stepButtons: {
    width: '100%',
    flexDirection: 'row', 
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 32,
    paddingHorizontal: 18
  }
});
